import { BrowserCacheLocation } from '@azure/msal-browser';
import { env } from '@helpers';

const hostUrl = new URL(document.URL).origin;

const apiBaseUrl = env(process.env.V2_API_BASE_URL, 'staging.rflx.co.uk/');

const supportRoot = 'https://support.reflexivity.com/';

export const config = {
  posthog: {
    apiKey: env(
      process.env.PUBLIC_POSTHOG_KEY,
      'phc_35D7KlZlWdxkmcD1DvL8krr8pwlO9rz9KvDGDUFsvCm'
    ),
    apiHost: env(process.env.PUBLIC_POSTHOG_HOST, 'https://ph.rflx.co.uk'),
    uiHost: 'https://us.posthog.com',
  },
  app: {
    version: env(process.env.V2_VERSION, ''),
    environment: env(process.env.V2_ENV_LEVEL, 'staging'),
    isLocalEnvironment: hostUrl === 'http://localhost:1234',
    featureFlags: env(process.env.V2_FEATURE_FLAGS, '')?.split(','),
    isTeamsApp: env(process.env.V2_TEAMS_APP, '') === 'true',
  },
  release: {
    date: env(process.env.V2_RELEASE_DATE, new Date().toISOString()),
    number: env(process.env.V2_RELEASE_NUMBER, '1.1.0'),
  },
  api: {
    root: `https://api.${apiBaseUrl}`,
    wsRoot: `wss://ws.${apiBaseUrl}v2/prices`,
    wsDelayedRoot: `wss://ws.${apiBaseUrl}v1/delayed-prices`,
    wsNotifierRoot: `wss://ws.${apiBaseUrl}v2/notifier`,
    authRoot: `https://authn.${apiBaseUrl}`,
  },
  urls: {
    root: hostUrl,
    webAppOrigin: env(process.env.WEBSITE_DOMAIN, hostUrl).replace(/\/$/, ''),
    supportRoot,
    supportNewTicket: `${supportRoot}hc/en-us/requests/new`,
    onboardingUrl: 'https://calendar.app.google/2FnsHDLsCwwoTCEW7',
    disclaimerFileUpload:
      'https://support.reflexivity.com/hc/en-us/articles/45048745062548-Important-Disclosure-about-Uploading',
    helpImportWatchlist:
      'https://support.reflexivity.com/hc/en-us/articles/29753957516564-How-to-import-your-watchlist-from-Bloomberg',
  },
  ib: {
    website:
      'https://ndcdyn.interactivebrokers.com/sso/Login?action=TA_MARKET_DATA&loginType=1&serviceID1=1357&serviceID2=1064&serviceID3=1065',
    linkDisclaimer: env(
      process.env.V2_IB_LINK_DISCLAIMER,
      'https://support.reflexivity.com/hc/en-us/articles/40656423190548-Important-Disclaimers-about-Direct-Linkage'
    ),
  },
  zendeskSubdomain: env(
    process.env.V2_ZENDESK_SUBDOMAIN,
    'https://toggleglobal.zendesk.com/api/v2/requests'
  ),
  supportUrl: 'https://support.reflexivity.com/hc/en-us/requests/new',
  stripePublicKey: env(
    process.env.V2_STRIPE_PUBLIC_KEY,
    'pk_test_51Mdw3pG1Cyr3tMwe60lnBGMRRRlj3ifDQ3wTTdVe2Lz7rIE8aQVg3ntM8wfhtGPyF431iUVl0Yo9k5pnUCdBUZWO00nRitX4J8'
  ),
  faro: {
    url: env(
      process.env.FARO_URL,
      'https://faro-collector-prod-us-east-2.grafana.net/collect/47d752fe88600d31a3c539c6455d7bc1'
    ),
  },
  microsoft: {
    config: {
      auth: {
        clientId: env(
          process.env.CLIENT_ID,
          '388983d4-d79a-4ef9-afb3-5d6d843b7e4f'
        ),
        authority: `https://login.microsoftonline.com/${env(
          process.env.TENANT_ID,
          'f89ffc33-8c4b-4997-8cb3-9bfe229ef9bd'
        )}`,
        redirectUri: env(
          process.env.REDIRECT_URI,
          'https://staging.rflx.co.uk/app/alfred/app-connection'
        ),
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
      },
    },
    scopes: [
      `api://${env(
        process.env.CLIENT_ID,
        '388983d4-d79a-4ef9-afb3-5d6d843b7e4f'
      )}/access_as_user`,
    ],
  },
  supportEmail: 'support@reflexivity.com',
  partnershipsEmail: 'partnerships@reflexivity.com',
};

export const webOnlyFeat = <T>(value: T): T | undefined =>
  config.app.isTeamsApp ? undefined : value;
